module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAMAAADjcdz2AAAAPFBMVEUAAAAwcL84cL81db84dMM3c8E3dMI4dME4dME3c8E4c8E3c8A4dMA4dME3dMA3c8A4c8A3c8A3dMA4dMGkOT2fAAAAE3RSTlMAECAwQG9wf4CQoK+/wM/Q3+/wILj6yQAAAG1JREFUGFd9zkESgjAQBdEOicOIRJC+/11doMaN9vJV/ZqBmEcNiKOPnCA7I9svqLtrAbSdsKnxDYe6AEY54ao2wHslO8RtyWWtn0lV1R3cKtmJE6x4KWQnX9Dek3aoupVx9u/r8VhHTkDkqMETjfsIYhLDOWYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/res/Recruit_Appt_Icon.png
// module id = 1128
// module chunks = 0